module.exports = __webpack_public_path__ + "img/1.db8ccde2.png";